import { render, staticRenderFns } from "./AddStepIngredientModal.vue?vue&type=template&id=13f810e4&scoped=true"
import script from "./AddStepIngredientModal.vue?vue&type=script&lang=js"
export * from "./AddStepIngredientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f810e4",
  null
  
)

export default component.exports